<div class="phx-select-items">
  <ng-container [ngTemplateOutlet]="phxShowSearch && dropdownSearch"> </ng-container>
  <div *ngIf="levelsStack?.length && phxShowHeader" class="phx-select-dropdown-back">
    <i (click)="showParent()" phx-icon [phxIcon]="ArrowLeftIcon"></i>
    <span>{{ headerTitle }}</span>
  </div>
  <ng-container
    *ngIf="(hasNoData$ | async) && !(phxEnableAddNewOption && isNewOptionValid)"
    [ngTemplateOutlet]="phxResultNotFound ? customNoDataTemplate : noDataTemplate"
  ></ng-container>

  <div class="phx-select-option-list-container" [ngStyle]="{'height': !phxDataSource && (loading$ | async) ? optionListLoaderHeight + 'px' : 'auto'}">
    <!-- Virtual scroll mode -->
    <ng-container *ngIf="phxVirtualScrollEnabled">
      <!-- Virtual scroll mode with custom strategy -->
      <cdk-virtual-scroll-viewport
        #virtualScrollViewport
        class="phx-select-virtual-scroll-viewport"
        *ngIf="isCustomScrollEnabled && ((phxDataSource && !(searchTerm && isSearchChanged)) || !(loading$ | async)) &&
          !((searched$ | async) ? searchedOptions?.length === 0 : (activeOptions$ | async)?.length === 0)"
        phxCustomVirtualScroll
        [phxCustomHeightPredictor]="customHeightPredictor"
        [phxOptions]="(searched$ | async) ? searchedOptions : (activeOptions$ | async)"
        [style]="virtualScrollViewportStyle"
        (keydown)="onOptionsKeydown($event)"
        (focus)="onOptionsFocus()"
        (scrolledIndexChange)="onScrollIndexChange($event)"
        selectFocusTrapItem="options"
        tabindex="-1"
      >
        <ng-container *cdkVirtualFor="let opt of (searched$ | async) ? searchedOptions : (activeOptions$ | async); index as i; trackBy: trackByFn; templateCacheSize: 20">
          <phx-select-option-item
            selectFocusableItem
            [isTreeView]="phxTreeView"
            [option]="opt"
            [optionHeight]="phxOptionHeight"
            [disabled]="opt.disabled"
            [label]="opt.label"
            [value]="opt.value"
            [subText]="opt.subText"
            [prefixIcon]="opt.prefixIcon"
            [isNestedOptions]="isNestedOptions"
            [groupLabel]="opt.groupLabel"
            [isLink]="opt.isLink"
            [showSubText]="phxShowSubText"
            [highlightSubtext]="phxHighlightSubtext"
            [shouldHighlightMatchedSubtext]="opt.shouldHighlightMatchedSubtext"
            [showRadio]="phxShowRadio"
            [searched]="(searched$ | async)"
            [searchedText]="searchTerm"
            [ancestors]="getAncestor(opt.value)"
            [isExpanded]="isTreeExpanded(opt.value)"
            [data]="opt.data"
            [children]="opt.children"
            [selected]="isOptionSelected(opt)"
            [multiple]="phxMultiple"
            [isDivider]="opt.isDivider"
            [showDivider]="i > 0"
            [optionTemplate]="opt.optionTemplate"
            [suffixTemplate]="opt.suffixTemplate"
            [isIndeterminate]="isOptionIndeterminate(opt)"
            [isMobileView]="isMobileView"
            [isLastOption]="i === ((searched$ | async) ? searchedOptions.length - 1 : (activeOptions$ | async)?.length - 1)"
            [isCustomScrollEnabled]="isCustomScrollEnabled"
            [isFocused]="focusedIndex >= 0 && i === focusedIndex"
            [tooltip]="opt.tooltip"
            [isCustomTooltipEnabled]="isCustomTooltipEnabled"
            [isTooltipOnTruncateEnabled]="isTooltipOnTruncateEnabled"
            [disableParentSelection]="phxDisableParentSelection"
            (mouseenter)="onOptionHover(opt, i)"
            (onSelect)="handleOptionClick($event, i)"
            (onShowChildren)="showChildren($event)"
            (onExpandCollapse)="expandCollapseTreeOption($event)"
            (onLinkClick)="handleLinkOptionClick($event)"
            (onLastOptionVisible)="onLastOptionVisible()"
          ></phx-select-option-item>
        </ng-container>
      </cdk-virtual-scroll-viewport>

      <!-- Virtual scroll mode with legacy strategy -->
      <cdk-virtual-scroll-viewport
        #virtualScrollViewport
        class="phx-select-virtual-scroll-viewport"
        *ngIf="!isCustomScrollEnabled && ((phxDataSource && !(searchTerm && isSearchChanged)) || !(loading$ | async)) &&
          !((searched$ | async) ? searchedOptions?.length === 0 : (activeOptions$ | async)?.length === 0)"
        [itemSize]="optionHeight"
        [style]="virtualScrollViewportStyle"
        [minBufferPx]="phxMinBufferMultiplier * optionHeight"
        [maxBufferPx]="phxMaxBufferMultiplier * optionHeight"
        (keydown)="onOptionsKeydown($event)"
        (focus)="onOptionsFocus()"
        (scrolledIndexChange)="onScrollIndexChange($event)"
        selectFocusTrapItem="options"
        tabindex="-1"
      >
        <ng-container *cdkVirtualFor="let opt of (searched$ | async) ? searchedOptions : (activeOptions$ | async); index as i; trackBy: trackByFn; templateCacheSize: 20">
          <phx-select-option-item
            selectFocusableItem
            [isTreeView]="phxTreeView"
            [optionHeight]="optionHeight"
            [option]="opt"
            [disabled]="opt.disabled"
            [label]="opt.label"
            [value]="opt.value"
            [subText]="opt.subText"
            [prefixIcon]="opt.prefixIcon"
            [isNestedOptions]="isNestedOptions"
            [groupLabel]="opt.groupLabel"
            [isLink]="opt.isLink"
            [showSubText]="phxShowSubText"
            [highlightSubtext]="phxHighlightSubtext"
            [shouldHighlightMatchedSubtext]="opt.shouldHighlightMatchedSubtext"
            [showRadio]="phxShowRadio"
            [searched]="(searched$ | async)"
            [searchedText]="searchTerm"
            [ancestors]="getAncestor(opt.value)"
            [isExpanded]="isTreeExpanded(opt.value)"
            [data]="opt.data"
            [children]="opt.children"
            [selected]="isOptionSelected(opt)"
            [multiple]="phxMultiple"
            [isDivider]="opt.isDivider"
            [showDivider]="i > 0"
            [optionTemplate]="opt.optionTemplate"
            [suffixTemplate]="opt.suffixTemplate"
            [isCustomScrollEnabled]="isCustomScrollEnabled"
            [isIndeterminate]="isOptionIndeterminate(opt)"
            [isFocused]="i === focusedIndex"
            [tooltip]="opt.tooltip"
            [isCustomTooltipEnabled]="isCustomTooltipEnabled"
            [isTooltipOnTruncateEnabled]="isTooltipOnTruncateEnabled"
            [disableParentSelection]="phxDisableParentSelection"
            (mouseenter)="onOptionHover(opt, i)"
            (onSelect)="handleOptionClick($event, i)"
            (onShowChildren)="showChildren($event)"
            (onExpandCollapse)="expandCollapseTreeOption($event)"
            (onLinkClick)="handleLinkOptionClick($event)"
          ></phx-select-option-item>
        </ng-container>
      </cdk-virtual-scroll-viewport>
    </ng-container>
    
    <!-- Regular scroll mode - No virtual scroll - this can be used when consumer need to show subtext on multiple lines.-->
    <div
      #optionsContainer
      class="phx-select-options-container"
      *ngIf="!phxVirtualScrollEnabled && ((phxDataSource && !(searchTerm && isSearchChanged)) || !(loading$ | async)) &&
        !((searched$ | async) ? searchedOptions?.length === 0 : (activeOptions$ | async)?.length === 0)"
      [style.maxHeight.px]="phxListHeight"
      (keydown)="onOptionsKeydown($event)"
      (focus)="onOptionsFocus()"
      selectFocusTrapItem="options"
      tabindex="-1"
    >
      <ng-container *ngFor="let opt of (searched$ | async) ? searchedOptions : (activeOptions$ | async); index as i; trackBy: trackByFn">
        <phx-select-option-item
          selectFocusableItem
          [isTreeView]="phxTreeView"
          [truncateSubtext]="phxTruncateSubText"
          [isVirtualScrollOption]="phxVirtualScrollEnabled"
          [optionHeight]="optionHeight"
          [option]="opt"
          [disabled]="opt.disabled"
          [label]="opt.label"
          [value]="opt.value"
          [subText]="opt.subText"
          [prefixIcon]="opt.prefixIcon"
          [isNestedOptions]="isNestedOptions"
          [groupLabel]="opt.groupLabel"
          [isLink]="opt.isLink"
          [showSubText]="phxShowSubText"
          [highlightSubtext]="phxHighlightSubtext"
          [shouldHighlightMatchedSubtext]="opt.shouldHighlightMatchedSubtext"
          [showRadio]="phxShowRadio"
          [searched]="(searched$ | async)"
          [searchedText]="searchTerm"
          [ancestors]="getAncestor(opt.value)"
          [isExpanded]="isTreeExpanded(opt.value)"
          [data]="opt.data"
          [children]="opt.children"
          [selected]="isOptionSelected(opt)"
          [multiple]="phxMultiple"
          [isDivider]="opt.isDivider"
          [showDivider]="i > 0"
          [optionTemplate]="opt.optionTemplate"
          [suffixTemplate]="opt.suffixTemplate"
          [isIndeterminate]="isOptionIndeterminate(opt)"
          [isFocused]="i === focusedIndex"
          [isLastOption]="i === ((searched$ | async) ? searchedOptions.length - 1 : (activeOptions$ | async)?.length - 1)"
          [tooltip]="opt.tooltip"
          [isCustomTooltipEnabled]="isCustomTooltipEnabled"
          [isTooltipOnTruncateEnabled]="isTooltipOnTruncateEnabled"
          [disableParentSelection]="phxDisableParentSelection"
          (mouseenter)="onOptionHover(opt, i)"
          (onSelect)="handleOptionClick($event, i)"
          (onShowChildren)="showChildren($event)"
          (onExpandCollapse)="expandCollapseTreeOption($event)"
          (onLinkClick)="handleLinkOptionClick($event)"
          (onLastOptionVisible)="onLastOptionVisible()"
        ></phx-select-option-item>
      </ng-container>
    </div>

    <div *ngIf="loading$ | async" class="phx-select-loading-icon">
      <phx-spinner [phxCentered]="!phxDataSource" phxSize="medium"></phx-spinner>
    </div>
  </div>
</div>
<div class="phx-select-footer">
  <phx-select-option-item
    *ngIf="phxEnableAddNewOption && searchTerm && isNewOptionValid"
    selectFocusTrapItem="add-opt"
    class="phx-select-add-new-option"
    [label]="searchTerm"
    [value]="searchTerm"
    [optionTemplate]="addNewOptionTemplate"
    [isCustomTooltipEnabled]="isCustomTooltipEnabled"
    [isTooltipOnTruncateEnabled]="isTooltipOnTruncateEnabled"
    (onSelect)="handleAddOptionClick($event)"
    tabindex="-2"
  ></phx-select-option-item>
  <ng-template #addNewOptionTemplate>
    <span>
      <span class="phx-select-add-new-option-text">{{ "Add" | phxTranslate }} </span><span class="phx-select-add-new-option-search-text">{{ searchTerm }}</span>
    </span>
  </ng-template>

  <div class="phx-select-footer-content" *ngIf="!(hasNoData$ | async) && (phxFooterRightTemplate || isShowClear)">
    <div *ngIf="isShowClear" class="phx-select-clear-btn">
      <ng-container *ngIf="phxMultiple">
        <span class="phx-select-footer-counter">{{ selectedOptionCount }} {{ "Selected" | phxTranslate }} </span>
        <span class="phx-select-footer-bullet"></span>
      </ng-container>
      <a
        selectFocusTrapItem="clear"
        class="phx-select-footer-clear"
        (click)="clearOption()"
        (keydown.enter)="onClearKeydown()"
        (keydown.space)="onClearKeydown()"
        (focus)="onTouched()"
        tabindex="-2"
      >
        {{ "Clear" | phxTranslate }}
      </a>
    </div>
    <div *ngIf="phxFooterRightTemplate" class="phx-select-footer-right">
      <ng-container *ngTemplateOutlet="phxFooterRightTemplate"></ng-container>
    </div>
  </div>
</div>

<ng-template #customNoDataTemplate>
  <div class="phx-select-no-result">
    <ng-container *ngIf="isNotFoundTemplateAvailable" [ngTemplateOutlet]="$any(phxResultNotFound)"></ng-container>
    <ng-container *ngIf="!isNotFoundTemplateAvailable">
      {{ $any(phxResultNotFound) | phxTranslate }}
    </ng-container>
  </div>
</ng-template>

<ng-template #noDataTemplate>
  <div class="phx-select-no-data">
    {{ searchTerm ? ("No results found" | phxTranslate) : ("No data found" | phxTranslate) }}
  </div>
</ng-template>

<ng-template #dropdownSearch>
  <phx-input-group class="phx-select-dropdown-search" [phxPrefix]="searchIcon" [phxSuffix]="clearIcon">
    <input
      #dropdownSearchInput
      selectFocusTrapItem="input"
      phx-input
      phxInputStyle="borderless"
      [attr.placeholder]="phxSearchPlaceholder | phxTranslate"
      [ngModel]="searchTerm"
      (input)="debouncedOnSearchChange($event)"
      (keydown)="onSearchInputKeydown($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      tabindex="-1"
    />
  </phx-input-group>
  <ng-template #clearIcon>
    <div class="phx-select-dropdown-search-prefix">
      <button
        *ngIf="searchTerm"
        phx-icon-button
        [phxIcon]="CrossIcon"
        phxIconButtonSize="extra-extra-small"
        selectFocusTrapItem="cross"
        class="phx-select-dropdown-search-close"
        (click)="onClearSearch()"
        (keydown.enter)="onClearSearch()"
        (focus)="onTouched()"
      ></button>
    </div>
  </ng-template>
  <ng-template #searchIcon>
    <i phx-icon class="phx-select-dropdown-search-icon" [phxIcon]="MagnifyingGlassIcon"></i>
  </ng-template>
</ng-template>

<ng-template #nestedSearchSubtext let-opt> </ng-template>
